export default __webpack_public_path__ + "static/media/logo.d204d9b9.png";